import { render, staticRenderFns } from "./expandableCard.vue?vue&type=template&id=9ae2cf26"
import script from "./expandableCard.vue?vue&type=script&lang=js"
export * from "./expandableCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports